import type { FormEvent } from 'react';
import React from 'react';

import { FormField, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { ASBESTOS } from '../../../constants';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function Asbestos({ section, setSectionValues }: Props) {
  function onAsbestosOnPropertyYesClick(): void {
    setSectionValues({
      [ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY]: true,
    });
  }

  function onAsbestosOnPropertyNoClick(): void {
    setSectionValues({
      [ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY]: false,
    });
  }

  function onDescriptionChange(event: FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [ASBESTOS.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  const asbestosOnProperty = section.getFieldValue(ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY);

  return (
    <FormField
      label={<Label size="lg">Do you know of any areas with asbestos on your property?</Label>}
      disabled={section.isFieldDisabled(ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY)}
      control={
        <YesAndNoExpansion
          yesHandler={onAsbestosOnPropertyYesClick}
          noHandler={onAsbestosOnPropertyNoClick}
          yesActive={asbestosOnProperty}
          disabled={section.isFieldDisabled(ASBESTOS.FIELD_NAME.HAS_ON_PROPERTY)}
        >
          <FormField
            label={<Label>Describe where on the property</Label>}
            control={
              <Textarea
                onChange={onDescriptionChange}
                value={section.getFieldValue(ASBESTOS.FIELD_NAME.DESCRIPTION)}
                resize="vertical"
                disabled={section.isFieldDisabled(ASBESTOS.FIELD_NAME.DESCRIPTION)}
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}
